import { FEEDBACK_PROMPT_ELIGIBILITY_MS, FeedbackPromptStatus } from 'constants/feedback-prompt'
import {
  getFeedbackPromptSnoozeUntil,
  getFeedbackPromptStatus,
  getFirstTestCompletedAt,
} from 'local-store/feedback-prompt'

/**
 * Returns whether the three-day product feedback prompt should be shown
 * after a completed typing test.
 */
export const isFeedbackPromptEligible = (): boolean => {
  if (typeof window === 'undefined') return false

  const firstTestCompletedAt = getFirstTestCompletedAt()

  if (firstTestCompletedAt === null) return false

  const status = getFeedbackPromptStatus()

  if (status === FeedbackPromptStatus.SUBMITTED || status === FeedbackPromptStatus.DISMISSED_FOREVER) {
    return false
  }

  if (status === FeedbackPromptStatus.SNOOZED) {
    const snoozeUntil = getFeedbackPromptSnoozeUntil()

    if (snoozeUntil !== null && Date.now() < snoozeUntil) {
      return false
    }
  }

  return Date.now() - firstTestCompletedAt >= FEEDBACK_PROMPT_ELIGIBILITY_MS
}
